import ModalWindow from '../Modal';
import styles from './BlockSelectAllModal.module.scss';
import Button from '../Button';
import React, { useEffect } from 'react';
import { useMixpanel } from 'react-mixpanel-browser';
import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

export function BlockSelectAllModal(props) {
  const mixpanel = useMixpanel();
  const supplier = useSelector((state) => state.role.supplier);
  const retailer = useSelector((state) => state.role.retailer);

  const getEventData = () => {
    if (props.retailerPage) {
      return { entityId: retailer?.id, entityName: retailer?.name, entityType: 'Retailer' };
    }
    return { entityId: supplier?.id, entityName: supplier?.name, entityType: 'Supplier' };
  };

  useEffect(() => {
    if (!props.open) return;
    const { entityId, entityName } = getEventData();
    reportBusinessActionToMixpanel(mixpanel, 'select-all-block-over-10k', { entityId, entityName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mixpanel, props.open, retailer, supplier]);

  return (
    <ModalWindow onClose={props.onClose} open={props.open} center>
      <hr />
      <p>You can select up to 10,000 items at a time.</p>
      <p> Please use filters to narrow your selection.</p>
      <div className={styles.footer}>
        <div className={styles.buttons}>
          <Button color="white" text="CLOSE" onClick={props.onClose} />
        </div>
      </div>
    </ModalWindow>
  );
}
BlockSelectAllModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
